export const CLASS_NAMES = {
  ownerMenu: 'idea-summary-owner-menu',
  ownerLoader: 'idea-summary-owner-loader',
  ownerAvatar: 'idea-summary-owner-avatar',
  ownerName: 'idea-summary-owner-name',
  ideaMenuButton: 'idea-menu-button',
} as const;
